module.exports = __webpack_public_path__ + "static/media/about-me.52d1cc8b.jpeg";